import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { OidcSecurityService, provideAuth } from 'angular-auth-oidc-client';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

import { routes } from './app.routes';
import { authConfig } from './core/auth/auth.config';
import { apiVersionInterceptor } from './core/interceptors/api-version.interceptor';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';

function initAuth(oidc: OidcSecurityService): () => Promise<void> {
  return () =>
    new Promise<void>((resolve) => {
      oidc.checkAuth().subscribe({
        next: () => resolve(),
        error: () => resolve(),
      });
    });
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([apiVersionInterceptor, authInterceptor, errorInterceptor]),
    ),
    provideAnimationsAsync(),
    provideAuth(authConfig),
    {
      provide: APP_INITIALIZER,
      useFactory: initAuth,
      deps: [OidcSecurityService],
      multi: true,
    },
    providePrimeNG({
      theme: {
        preset: definePreset(Aura, {
          semantic: {
            primary: {
              50: '{blue.50}',
              100: '{blue.100}',
              200: '{blue.200}',
              300: '{blue.300}',
              400: '#1B6DB5',
              500: '#1B6DB5',
              600: '#155D9E',
              700: '#104D87',
              800: '#0B3D70',
              900: '#072D59',
              950: '#041E42',
            },
            colorScheme: {
              dark: {
                primary: {
                  color: '#00d4ff',
                  contrastColor: '#0a1520',
                  hoverColor: '#33dfff',
                  activeColor: '#00a8cc',
                },
              },
            },
          },
        }),
        options: {
          darkModeSelector: '.app-dark',
        },
      },
    }),
    MessageService,
  ],
};
